module.exports = __webpack_public_path__ + "img/ceramic-artist.15254fbc.webp";